import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const groupMatchEntry = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    groupMatchId: z.number().hidden().describe('Foreign key to GroupMatch'),

    matchId: z.number().presentAs('reference').describe('Foreign key to Match'),

    groupMatch: belongsTo('GroupMatch'),

    match: references('Match'),
  })
  .describe(
    "Links a group match to one pair's match. A legacy match can belong to\nseveral group matches, because the old system reused an earlier run of the\nsame pair instead of running it again.",
  )
  .meta({ readAs: '{match} in {groupMatch}' })
  .as('GroupMatchEntry');

export { groupMatchEntry as groupMatchEntrySchema };
